module.exports = __webpack_public_path__ + "img/ico_ugc_shorts.3ce6826.svg";